import axios from 'axios';
import Carousel from '../../components/Carousel/Carousel';
import {useState, useEffect} from 'react';
import Hero from '../../components/Hero/Hero';
import { url, token } from '../../utils/Config/config';
import { SwiperSlide } from 'swiper/react';
import { NavLink } from 'react-router-dom';
import GameCard from '../../components/Card/GameCard';
import Card from '../../components/Card/Card';

const Homepage = () => {

    const [popularGames, setPopularGames] = useState([]);
    const [upcomingGames, setUpcomingGames] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const getPopularGames = async () => {
            setLoading(true);
            try {
                let response = await axios.get(`${url}/games?dates=2021-01-01,2021-12-31&ordering=-added&key=${token}`);
                setPopularGames(response.data.results);
                setLoading(false);
            } catch(e) {
                setLoading(true);
                console.log(e.message);
            }
        }
        getPopularGames();

        const getUpcomingGames = async () => {
            setLoading(true);
            try {
                let response = await axios.get(`${url}/games?dates=2021-01-01,2021-12-30&ordering=-added&key=${token}`);
                setUpcomingGames(response.data.results);
                setLoading(false);
            } catch(e) {
                setLoading(true);
                console.log(e.message);
            }
        }
        getUpcomingGames();
        
    }, []);

    return (
        <div>
            <Hero />
            <section id="popular">
            {loading ? 
                <div className="container">
                    <div className="row pt-md-5">
                        <div className="col">
                            <p className="text-center">Loading...</p>
                        </div>
                    </div>
                </div> : 
                <Carousel
                    carouselTitle="Most Popular Games in 2021"
                    content={popularGames.map((popGame, index) => {
                    return(
                        <SwiperSlide key={index}>
                            <NavLink className="card-link" to={`/games/${popGame.slug}`}>
                                <GameCard 
                                    thumbnail={popGame.background_image}
                                    title={popGame.name}
                                    rating={popGame.rating}
                                />
                            </NavLink>
                        </SwiperSlide>
                        );
                    })}
                />
            }
            </section>
            <section id="upcoming"> 
                <div className="container">
                    <div className="row my-5">
                        <div className="col">
                            <h2 className="ms-md-5">Upcoming Games</h2>
                        </div>
                    </div>
                    {loading ? 
                        <div className="row px-md-5">
                            <div className="col">
                                <p className="text-center">Loading...</p>
                            </div>
                        </div> :
                        <div className="row px-md-5">   
                            {upcomingGames.map((upcomingGame, index) => {
                                return(
                                    <div className="col-md-3 mb-4" key={index}>
                                        <NavLink className="card-link" to={`/games/${upcomingGame.slug}`}>
                                            <Card 
                                                img={upcomingGame.background_image}
                                                title={upcomingGame.name}
                                                rating={upcomingGame.rating}
                                            />
                                        </NavLink>
                                    </div>
                                    );
                                })}
                        </div>
                    }
                </div>
            </section>
        </div>
    )
}

export default Homepage;
